import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

interface BrandsState {
    fetching: FetchingTypes;
    brands: {
        brands: any[];
        fetching: FetchingTypes;
    };
    publications: {
        fetching: FetchingTypes;
        brands: any[];
    };
    publicationById: {
        fetching: FetchingTypes;
        publication: any;
    };
}

const initialState: BrandsState = {
    fetching: "unknown",
    brands: {
        fetching: "unknown",
        brands: []
    },
    publications: {
        fetching: "unknown",
        brands: []
    },
    publicationById: {
        fetching: "unknown",
        publication: []
    }
};

const brandsSlice = createSlice({
    name: "brands",
    initialState,
    reducers: {
        getBrandsRequest: (state) => {
            state.brands.fetching = "loading";
        },
        getBrandsSuccess: (state, action) => {
            state.brands.fetching = "success";
            state.brands = action.payload.brands;
        },
        getBrandsFailure: (state) => {
            state.brands.fetching = "failure";
            state.brands = initialState.brands;
        },
        getBrandsPublicationsRequest: (state) => {
            state.publications.fetching = "loading";
        },
        getBrandsPublicationsSuccess: (state, action) => {
            state.publications.fetching = "success";
            state.publications.brands = action.payload.brands;
        },
        getBrandsPublicationsFailure: (state) => {
            state.publications.fetching = "failure";
            state.publications.brands = initialState.publications.brands;
        },
        getBrandsPublicationsByIdRequest: (state) => {
            state.publicationById.fetching = "loading";
        },
        getBrandsPublicationsByIdSuccess: (state, action) => {
            state.publicationById.fetching = "success";
            state.publicationById.publication = action.payload.publication;
        },
        getBrandsPublicationsByIdFailure: (state) => {
            state.publicationById.fetching = "failure";
            state.publicationById.publication = initialState.publicationById.publication;
        },
        cleanBrands: () => initialState
    }
});

export const {
    getBrandsRequest,
    getBrandsSuccess,
    getBrandsFailure,
    getBrandsPublicationsRequest,
    getBrandsPublicationsSuccess,
    getBrandsPublicationsFailure,
    getBrandsPublicationsByIdRequest,
    getBrandsPublicationsByIdSuccess,
    getBrandsPublicationsByIdFailure,
    cleanBrands,
} = brandsSlice.actions;

export default brandsSlice.reducer;